export default (parts, delimiter = ', ') =>
  parts
    .filter((r) => !!r) // filter empty results
    .join(delimiter);
